
export const convertToDate = (dateString: string): Date | null => {
  if (dateString.length !== 8) {
    console.error("Invalid date format. Must be 8 digits.");
    return null;
  }

  const year = parseInt(dateString.substring(0, 4), 10);
  const month = parseInt(dateString.substring(4, 6), 10) - 1; // Months are 0-indexed in JavaScript
  const day = parseInt(dateString.substring(6, 8), 10);

  // Create a new Date object with UTC time to avoid time zone issues
  const date = new Date(Date.UTC(year, month, day));

  if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month || date.getUTCDate() !== day) {
    console.error("Invalid date.");
    return null;
  }

  return date;
};